export enum ImageStatus {
  UnMatched = 'unmatched',
  Matched = 'matched',
  PartialMatched = 'partialMatched',
}
